import React from "react";
import { Moon, Sun } from "lucide-react";
import { useTheme } from "../lib/theme";
import { useI18n } from "../lib/i18n";

export function ThemeSwitch({ className = "" }) {
  const { theme, toggle } = useTheme();
  const { t } = useI18n();
  const dark = theme === "dark";
  return (
    <button
      onClick={toggle}
      data-testid="theme-switch"
      title={t("theme.toggle")}
      className={`group inline-flex shrink-0 items-center gap-2 rounded-full border border-edge raise px-3 py-1.5 transition-colors duration-200 hover:border-aegis-cyan/40 ${className}`}
    >
      {dark ? (
        <Moon size={13} className="text-aegis-cyan" />
      ) : (
        <Sun size={13} className="text-aegis-amber" />
      )}
      <span className="hidden font-mono text-[11px] text-slate-400 group-hover:text-slate-200 md:inline" data-testid="theme-label">
        {dark ? t("theme.dark") : t("theme.light")}
      </span>
    </button>
  );
}
